export default "__VITE_ASSET__BTxFoOll__"